// This is cookie banner script provided by Crown Peak (previously known as Evidon)
import { browserDoNotTrack } from 'Roblox';
import utils from '../../utils/utils';
import { CONSENT_COOKIE_NAME, CUSTOM_CONSENT_COOKIE } from '../constants/cookieConstants';

function handleGoogleAnalytics() {
  if (!browserDoNotTrack) {
    const ga = document.createElement('script');
    ga.type = 'text/javascript';
    ga.async = true;
    ga.src = `${
      document.location.protocol === 'https:' ? 'https://ssl' : 'http://www'
    }.google-analytics.com/ga.js`;
    const s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(ga, s);
  }
}

function originalEvidonScript(id) {
  function append(scriptid, url, async) {
    const d = document;
    const sn = 'script';
    let f = d.getElementsByTagName(sn)[0];

    // prevent loading in iframe
    if (!utils.inIframe()) {
      if (!f) f = d.head;
      const s = d.createElement(sn);
      s.async = async;
      s.id = scriptid;
      s.src = url;
      s.charset = 'utf-8';
      f.parentNode.insertBefore(s, f);
    }
  }

  function is2parttld(value) {
    const tldindicators = ['co', 'com', 'info', 'web', 'info', 'gov', 'edu', 'biz', 'net', 'org'];
    const countryindicators = [
      'uk',
      'us',
      'fr',
      'es',
      'de',
      'at',
      'au',
      'ae',
      'be',
      'br',
      'ca',
      'ch',
      'cn',
      'co',
      'cz',
      'dk',
      'eg',
      'eu',
      'fi',
      'gb',
      'gr',
      'hk',
      'hr',
      'hu',
      'ie',
      'in',
      'jp',
      'mx',
      'nl',
      'no',
      'nz',
      'pl',
      'ro',
      'ru',
      'se'
    ];
    return tldindicators.indexOf(value) !== -1 || countryindicators.indexOf(value) !== -1;
  }

  function getRootDomain() {
    let rootDomain;
    const parts = window.location.hostname.split('.');
    if (parts.length === 2) rootDomain = parts[0];
    else if (parts.length > 2) {
      // see if the next to last value is a common tld
      const part = parts[parts.length - 2];
      if (is2parttld(part)) {
        rootDomain = parts[parts.length - 3]; // go back one more
      } else {
        rootDomain = part;
      }
    }

    return rootDomain;
  }

  window.evidon = {};
  window.evidon.id = id;
  window.evidon.test = false; // set to true for non-production testing.
  // window.evidon.userid = '';

  const cdn = '//c.evidon.com/';
  const rootDomain = getRootDomain();
  const noticecdn = `${cdn}sitenotice/`;
  append('evidon-notice', `${noticecdn}evidon-sitenotice-tag.js`, false);
  append('evidon-location', `${cdn}geo/country.js`, true);
  append('evidon-themes', `${noticecdn + id}/snthemes.js`, true);
  if (rootDomain)
    append(
      'evidon-settings',
      `${noticecdn + id}/${rootDomain}${window.evidon.test ? '/test' : ''}/settings.js`,
      true
    );

  window.evidon.priorConsentCallback = (categories, vendors) => {
    // add the tags which need to wait for prior consent
    // here.  This should be all your advertising tags and
    // probably most of your social and tracking tags.
    const handlers = {
      categories: {},
      vendors: {
        'amazon-web-services': 'handleAmazonWebServices',
        'google-analytics': 'handleGoogleAnalytics'
      }
    };

    let handler;
    for (const category in categories) {
      if (Object.prototype.hasOwnProperty.call(categories, category)) {
        handler = window.evidon[handlers.categories[category]];
        if (typeof handler === 'function') handler();
      }
    }

    for (const vendor in vendors) {
      if (Object.prototype.hasOwnProperty.call(vendors, vendor)) {
        handler = window.evidon[handlers.vendors[vendor]];
        if (typeof handler === 'function') handler();
      }
    }
    if (vendors['google-analytics'] || vendors.all === true) {
      handleGoogleAnalytics();
    }
    const consentCookie = utils.getCookie(CONSENT_COOKIE_NAME);
    if (!consentCookie) {
      utils.setCookie(CUSTOM_CONSENT_COOKIE, 'non-GDPR', 365);
    }
  };

  window.evidon.closeCallback = () => {
    // this is executed if the user closed a UI element without either Accepting (providing consent)
    // or Declining (declining to provide consent).
  };

  window.evidon.consentWithdrawnCallback = () => {
    // this is exeucted if the user withdraws consent and elects to
    // no longer allow technologies to run on the site.
  };

  window.evidon.consentDeclinedCallback = () => {
    // this is executed if the user explicitly declines giving consent by
    // using a Decline button
  };

  // this is to clean up the duplicate name cookie
  // will clean up after a period of time
  const consentCookie = utils.getCookie(CONSENT_COOKIE_NAME);
  if (consentCookie === 'non-GDPR') {
    utils.setCookie(CONSENT_COOKIE_NAME, '', -366);
  }
}

(function (id) {
  function append(scriptid, url, async) {
    const d = document;
    const sn = 'script';
    let f = d.getElementsByTagName(sn)[0];

    if (!f) f = d.head;

    const s = d.createElement(sn);

    s.async = async;

    s.id = scriptid;

    s.src = url;

    s.charset = 'utf-8';

    f.parentNode.insertBefore(s, f);
  }

  // Let's pull down the geo file and see where we are:

  const cdn = '//c.evidon.com/';
  const eeaCountryArray = [
    'uk',
    'fr',
    'ie',
    'be',
    'nl',
    'fi',
    'no',
    'ai',
    'bm',
    'ky',
    'tc',
    'bg',
    'cz',
    'dk',
    'cy',
    'lv',
    'lt',
    'lu',
    'es',
    'hr',
    'it',
    'pl',
    'pt',
    'ro',
    'si',
    'hu',
    'mt',
    'nl',
    'at',
    'is',
    'li',
    'sk',
    'se',
    'de',
    'ee',
    'el',
    'hu',
    'ie',
    'it',
    'gf',
    'gp',
    'mq',
    'yt',
    're',
    'mf',
    'gi',
    'io',
    'vg',
    'fk',
    'gb'
  ];

  append('evidon-location', `${cdn}geo/country.js`, false);
  let intervalCheck;
  const checkIfLocationIsReady = () => {
    if (Object.prototype.hasOwnProperty.call(window, 'evidon')) {
      clearInterval(intervalCheck);
      if (eeaCountryArray.indexOf(window.evidon.location.code) !== -1) {
        originalEvidonScript(id);
      } else {
        const consentCookie = utils.getCookie(CONSENT_COOKIE_NAME);
        if (!consentCookie) {
          utils.setCookie(CUSTOM_CONSENT_COOKIE, 'non-GDPR', 365);
        } else {
          // invalid evidon consent cookie for non-EEA users
          utils.setCookie(CONSENT_COOKIE_NAME, '', -366);
        }
        const noticeLink = document.getElementsByClassName('evidon-notice-link')[0];
        if (noticeLink) {
          noticeLink.style.display = 'none';
        }
        handleGoogleAnalytics();
      }
    }
  };
  intervalCheck = setInterval(checkIfLocationIsReady, 100);
})(3822);
